import Input from './input'
import { InputSizes, InputTypes } from './constants'

export { InputSizes, InputTypes }

export default Input
